import { useOrganizations } from '@contexts/organizations-provider';
import { useInstructorsUnapproved } from '@features/instructors/hooks/use-instructors-unapproved/useInstructorsUnapproved';
import * as React from 'react';

import type {
  InstructorsUnapprovedContextValue,
  InstructorsUnapprovedProviderProps,
} from './InstructorsUnapprovedContext.types';

const InstructorsUnapprovedContext = React.createContext<
  InstructorsUnapprovedContextValue | undefined
>(undefined);

const InstructorsUnapprovedProvider = React.memo(
  ({
    children,
  }: Readonly<InstructorsUnapprovedProviderProps>): React.ReactElement => {
    const { selectedOrganization } = useOrganizations();

    const { data, isLoading, isFetching, isError, refetch } =
      useInstructorsUnapproved({
        customerId: selectedOrganization?.customerId ?? '',
      });

    const contextValue: InstructorsUnapprovedContextValue = React.useMemo(
      () => ({ data, isLoading, isFetching, isError, refetch }),
      [data, isLoading, isFetching, isError, refetch]
    );

    return (
      <InstructorsUnapprovedContext value={contextValue}>
        {children}
      </InstructorsUnapprovedContext>
    );
  }
);

InstructorsUnapprovedProvider.displayName = 'InstructorsUnapprovedProvider';
export { InstructorsUnapprovedProvider, InstructorsUnapprovedContext };
